import React from 'react';
import { useSelector } from 'react-redux';
import { HandoffCompletedScreen } from '../../../connectivity/screens/HandoffCompletedScreen/HandoffCompletedScreen';
import { AppState } from '../../../stores/redux-store';

export const HandoffCompletedConnected = () => {
  const clientName = useSelector((state: AppState) => state.oauth.description?.clientName);

  return <HandoffCompletedScreen clientName={clientName || ''} />;
};
